import { render, staticRenderFns } from "./ButtonSideNav.vue?vue&type=template&id=0c7c77d5&"
import script from "./ButtonSideNav.vue?vue&type=script&lang=js&"
export * from "./ButtonSideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports